import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrganizationMember } from '../models/staff/organization-member.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class StaffOrganizationMemberService extends RequestService<OrganizationMember> {
  static PATH = '/staff/organization/member';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(
      httpClient,
      StaffOrganizationMemberService.PATH,
      globalService.debugUrl
    );
  }
}
